module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export
	
	var flywheel = __webpack_require__(1).default;
	
	module.exports = flywheel;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ax = _axios2.default.create({
	  baseURL: 'https://mobile.flywheel.com'
	});
	
	// We pass the data to the promises objects, not the status, headers and config
	ax.interceptors.response.use(function (response) {
	  return response.data;
	}, function (error) {
	  return Promise.reject(error.data);
	});
	
	var _verifyRequiredParams = function _verifyRequiredParams(params) {
	  var missingParams = [];
	  Object.keys(params).forEach(function (key) {
	    if (!params[key]) {
	      missingParams.push(key);
	    }
	  });
	  if (missingParams.length > 0) {
	    throw new Error('Missing parameters: ' + missingParams);
	  }
	};
	
	var _authorizedGetRequest = function _authorizedGetRequest(requiredParams, path, authToken) {
	  _verifyRequiredParams(requiredParams);
	  return ax.get(path, {
	    params: {
	      auth_token: authToken
	    }
	  });
	};
	
	/**
	The flywheeljs library main exported object
	@namespace {object} flywheel
	*/
	var flywheel = {
	
	  /**
	   * The type of the object returned with a successfully resolved signup promise.
	   * @name SignupPromise
	   * @typedef {object} SignupPromise
	   * @property {string} auth_token - The token that can be used to authenticate future requests
	   * @property {object} passenger - An object including the user information. Some relevant fields are: `id`, `first_name`, `last_name`, and `email`.
	   */
	  /**
	   * Sign up a new user for the Flywheel service
	   *
	   * @example
	   * flywheel.signup({
	   *   firstName: 'John',
	   *   email: 'john@doe.com',
	   *   password: 'johndoe123',
	   *   telephone: '123123123',
	   *   latitude: 37.615223,
	   *   longitude: -122.389977
	   * })
	   * .then(response => {
	   *   console.log(response.data.passenger);
	   * })
	   * .catch(response => {
	   *   console.log(response.data.error);
	   * });
	   * @param {object} options - Options object parameter
	   * @param {string} options.firstName - Flywheel user first name
	   * @param {string} options.email - Flywheel user email
	   * @param {string} options.password - Flywheel user password
	   * @param {string} options.telephone - Flywheel user phone number
	   * @param {number} [options.latitude=0] - Default latitude (in degrees). This value can be overriden when ordering a cab
	   * @param {number} [options.longitude=0] - Default longitude (in degrees). This value can be overriden when ordering a cab
	   * @return {Promise} A promise that returns {@link SignupPromise} if resolved and an object containing the error if rejected.
	  */
	
	  signup: function signup() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var firstName = _ref.firstName;
	    var email = _ref.email;
	    var password = _ref.password;
	    var telephone = _ref.telephone;
	    var _ref$latitude = _ref.latitude;
	    var latitude = _ref$latitude === undefined ? 0 : _ref$latitude;
	    var _ref$longitude = _ref.longitude;
	    var longitude = _ref$longitude === undefined ? 0 : _ref$longitude;
	
	    _verifyRequiredParams({ firstName: firstName, email: email, password: password, telephone: telephone });
	    return ax.post('/passengers', {
	      first_name: firstName,
	      email: email,
	      password: password,
	      telephone: telephone,
	      latitude: parseFloat(latitude),
	      longitude: parseFloat(longitude),
	      adjust_xid_type: 'idfa',
	      adjust_xid: '12345678-1234-1234-1234-123456789012',
	      persistent_device_id: '12345678-1234-1234-1234-123456789012'
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved search promise.
	   * @name SearchPromise
	   * @typedef {object} SearchPromise
	   * @property {array} drivers - An array containing the drivers available at that location. Some relevant fields are: `id`, `vehicle`, `latitude` and `longitude`.
	   */
	  /**
	   * Search for cabs around a given position
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} [options.by='location'] - The field to search by
	   * @param {string} [options.filter='hailable'] - A filter to be applied to the search request
	   * @param {number} [options.latitude=0] - Default latitude (in degrees) used when ordering cabs
	   * @param {number} [options.longitude=0] - Default longitude (in degrees) used when ordering cabs
	   * @param {number} [options.authToken='(null)'] - User authentication token (if she's logged)
	   * @return {Promise} A promise that returns {@link SearchPromise} if resolved and an object containing the error if rejected.
	  */
	  search: function search() {
	    var _ref2 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var _ref2$by = _ref2.by;
	    var by = _ref2$by === undefined ? 'location' : _ref2$by;
	    var _ref2$filter = _ref2.filter;
	    var filter = _ref2$filter === undefined ? 'hailable' : _ref2$filter;
	    var _ref2$latitude = _ref2.latitude;
	    var latitude = _ref2$latitude === undefined ? 0 : _ref2$latitude;
	    var _ref2$longitude = _ref2.longitude;
	    var longitude = _ref2$longitude === undefined ? 0 : _ref2$longitude;
	    var _ref2$authToken = _ref2.authToken;
	    var authToken = _ref2$authToken === undefined ? '(null)' : _ref2$authToken;
	
	    return ax.get('/search', {
	      params: {
	        by: by,
	        filter: filter,
	        latitude: parseFloat(latitude),
	        longitude: parseFloat(longitude),
	        auth_token: authToken
	      }
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved login promise.
	   * @name LoginPromise
	   * @typedef {object} LoginPromise
	   * @property {string} auth_token - The token that can be used to authenticate future requests
	   * @property {object} passenger - An object including the user information. Some relevant fields are: `id`, `first_name`, `last_name`, and `email`.
	   * @property {object} scheduled_rides - An array containing the user scheduled rides
	   */
	  /**
	   * Login a user
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} options.email - The user email
	   * @param {string} options.password - The user password
	   * @return {Promise} A promise that returns {@link LoginPromise} if resolved and an object containing the error if rejected.
	  */
	  login: function login(_ref3) {
	    var email = _ref3.email;
	    var password = _ref3.password;
	
	    _verifyRequiredParams({ email: email, password: password });
	    return ax.post('/login', {
	      email: email,
	      password: password
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved application context promise. I added a question mark on those properties that are not clear to me.
	   * @name ApplicationContextPromise
	   * @typedef {object} ApplicationContextPromise
	   * @property {array} service_availabilities - An array of the services available at the given location. The service 'id' parameter is required for other requests (createRide, for example)
	   * @property {object} on_board_cancellation_window - The amount of time (in secs) allowed to cancel a ride without being charged
	   * @property {object} application_details - Some applications details, like the url on the app store
	   * @property {number} flywheel_service_fee - The fee charged by flywheel (in cents)
	   * @property {number} hailing_distance - Max hailing distance in meters (?)
	   * @property {number} maximum_hail_time - Max hail time in secs (before a request fails?)
	   * @property {number} straight_line_approximation_speed - ?
	   * @property {array} points_of_interest - ?
	   * @property {array} alerts - ?
	   * @property {number} on_board_cancellation_window - The amount of time (in secs) where a cancellation is not charged (?)
	   * @property {number} gps_warning_distance - ?
	   * @property {string} preferred_eta_provider - ?
	   * @property {number} booked_ride_countdown_window - ?
	   * @property {object} invite_friends - Referral rewards (in cents)
	   * @property {string} time_zone_identifier - Time zone
	   * @property {number} utc_offset - Offset (in secs) from UTC time
	   * @property {string} share_eta_msg - Some string used in the app UI
	   * @property {bool} enable_asking_point - ?
	  */
	  /**
	   * Get some application context data given a specific location.
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} options.authToken - An authentication token
	   * @param {number} options.latitude - A given latitude (in degrees) used when ordering cabs
	   * @param {number} options.longitude - A given longitude (in degrees) used when ordering cabs
	   * @return {Promise} A promise that returns {@link ApplicationContextPromise} if resolved and an object containing the error if rejected.
	  */
	  applicationContext: function applicationContext(_ref4) {
	    var authToken = _ref4.authToken;
	    var _ref4$latitude = _ref4.latitude;
	    var latitude = _ref4$latitude === undefined ? 0 : _ref4$latitude;
	    var _ref4$longitude = _ref4.longitude;
	    var longitude = _ref4$longitude === undefined ? 0 : _ref4$longitude;
	
	    return ax.get('/application_context', {
	      params: {
	        application: 'Flywheel',
	        platform: 'ios',
	        version: '5.6.7',
	        platform_version: '9.2.1',
	        latitude: parseFloat(latitude),
	        longitude: parseFloat(longitude),
	        auth_token: authToken
	      }
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved user info promise. I added a question mark on those properties that are not clear to me.
	   * @name UserInfoPromise
	   * @typedef {object} UserInfoPromise
	   * @property {string} id - The user (passenger) id
	   * @property {string} first_name - The user first name
	   * @property {string} last_name - The user last name
	   * @property {string} email - The user email
	   * @property {bool} has_dummy_email - True if the user has a dummy email (whatever that might mean)
	   * @property {string} telephone - The user telephone
	   * @property {string} canonical_telephone - ?
	   * @property {array} addresses - The user addresses
	   * @property {array} mobile_devices - The user mobile devices
	   * @property {array} dispatch_service_accounts - ?
	   * @property {number} default_tip_percent - Default tip percentage
	   * @property {number} credit_balance - ?
	   * @property {number} credits_since_last_session - ?
	   * @property {array} payment_instruments - The payment instruments linked to this user. The payment object contains a property `token` that is required for creating rides
	   * @property {number} payment_instruments_count - Number of payment instruments
	   * @property {string} latest_ride_id - Latest ride id
	   * @property {string} referral_code - Referral code for this user
	   * @property {string} latest_ride_id - Latest ride id
	   * @property {array} nonfatal_errors - ?
	   * @property {array} disabled_features - ?
	   * @property {string} oauth_id - ?
	   * @property {string} oauth_provider - I guess Google, FB, etc.
	   * @property {bool} sms_verification_required - ?
	   * @property {bool} is_agent_also - ?
	   * @property {string} added_by - ?
	   * @property {array} special_characteristics - ?
	   * @property {bool} ivr_blocked - ?
	   * @property {bool} newly_added - ?
	   * @property {object} suspended_upto - ?
	  */
	  /**
	   * Get user info
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} options.userId - The user id. It can be obtained from the 'passenger' object after logging in
	   * @param {string} options.authToken - The authentication token
	   * @return {Promise} A promise that returns {@link UserInfoPromise} if resolved and an object containing the error if rejected.
	  */
	  userInfo: function userInfo(_ref5) {
	    var userId = _ref5.userId;
	    var authToken = _ref5.authToken;
	
	    return _authorizedGetRequest({ userId: userId, authToken: authToken }, '/passengers/' + userId, authToken);
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved search promise.
	   * @name ETAPromise
	   * @typedef {object} ETAPromise
	   * @property {string} status - "OK" if the location can be reached
	   * @property {array} response - An array that contains at least one object with the estimated durations. It has the following properties: 'duration' (in secs), 'duration_in_traffic' (in secs) and 'distance'
	   */
	  /**
	   * Get estimated time of arrival
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} options.origin - The user id. It can be obtained from the 'passenger' object after logging in)
	   * @param {string} options.authToken - The authentication token
	   * @return {Promise} A promise that returns {@link ETAPromise} if resolved and an object containing the error if rejected.
	  */
	  eta: function eta(_ref6) {
	    var origin = _ref6.origin;
	    var destination = _ref6.destination;
	    var authToken = _ref6.authToken;
	
	    _verifyRequiredParams({ origin: origin, destination: destination, authToken: authToken });
	    return ax.get('/eta', {
	      params: {
	        origins: origin,
	        destinations: destination,
	        auth_token: authToken
	      }
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved ride promise. It includes a lot of properties, only the most interesting ones are documented here.
	   * @name RidePromise
	   * @typedef {object} RidePromise
	   * @property {string} id - The ride id
	   * @property {string} notes - The notes attached to the ride, created by the user
	   * @property {string} status - `hailing` if the ride is still to be assigned, `hail_accepted` if a cab driver accepted the ride, `canceled` if it's been canceled
	   * @property {string} failure_reason - The reason why the ride failed, if any
	   * @property {string} client_created_at - Formatted creation date
	   * @property {number} created_at - Creation timestamp
	   * @property {number} updated_at - The reason why the ride failed
	   * @property {object} passenger - An object with the same structure than {@link UserInfoPromise}
	   * @property {object} pick_up_location - Pick up location
	   * @property {object} drop_off_location - Drop off location (can be empty)
	   * @property {object} hail - This object contains all details about the `hail`, including the driver information
	   * @property {object} payment_instrument - The payment instrument used to pay for this ride
	   */
	  /**
	   * Create a new request for a ride
	   *
	   * @param {object} options - Options object parameter
	   * @param {number} options.pickUpLat - Pickup latitude (in degrees)
	   * @param {number} options.pickUpLon - Pickup latitude (in degrees)
	   * @param {string} options.address - The pickup address, for example: "22 Estate Ct". Use some geocoding service like google maps to obtain it: http://maps.googleapis.com/maps/api/geocode/json?address=<user_typed_address>
	   * @param {string} options.state - The state short name, for example: "CA". Use some geocoding service like google maps to obtain it: http://maps.googleapis.com/maps/api/geocode/json?address=<user_typed_address>
	   * @param {string} options.country - The country name, for example: "United States". Use some geocoding service like google maps to obtain it: http://maps.googleapis.com/maps/api/geocode/json?address=<user_typed_address>
	   * @param {string} options.city - The city name, for example: "South San Francisco". Use some geocoding service like google maps to obtain it: http://maps.googleapis.com/maps/api/geocode/json?address=<user_typed_address>
	   * @param {object} options.passenger - The passenger object. Only 'name' (string) and 'telephone' (string) are required
	   * @param {string} options.serviceAvailabilitiesId - The service id. It can be obtained using `applicationContext()`
	   * @param {number} options.tip - The ride tip (in cents)
	   * @param {string} options.authToken - The authentication token
	   * @param {string} options.notes - Any notes to be sent to the cab driver
	   * @return {Promise} A promise that returns {@link RidePromise} if resolved and an object containing the error if rejected.
	  */
	  createRide: function createRide(_ref7) {
	    var pickUpLat = _ref7.pickUpLat;
	    var pickUpLon = _ref7.pickUpLon;
	    var address = _ref7.address;
	    var state = _ref7.state;
	    var country = _ref7.country;
	    var city = _ref7.city;
	    var passenger = _ref7.passenger;
	    var paymentToken = _ref7.paymentToken;
	    var serviceAvailabilitiesId = _ref7.serviceAvailabilitiesId;
	    var _ref7$tip = _ref7.tip;
	    var tip = _ref7$tip === undefined ? 500 : _ref7$tip;
	    var _ref7$authToken = _ref7.authToken;
	    var authToken = _ref7$authToken === undefined ? '(null)' : _ref7$authToken;
	    var _ref7$notes = _ref7.notes;
	    var notes = _ref7$notes === undefined ? '' : _ref7$notes;
	
	    _verifyRequiredParams({ pickUpLat: pickUpLat, pickUpLon: pickUpLon, address: address, state: state, country: country, city: city, passenger: passenger, paymentToken: paymentToken, serviceAvailabilitiesId: serviceAvailabilitiesId });
	    var clientCreatedAt = new Date().toISOString().replace(/T/g, '-').slice(0, -5);
	    return ax.post('/rides', {
	      source: 'Mobile:iOS:5.6.7:Flywheel',
	      pick_up_location: {
	        latitude: parseFloat(pickUpLat),
	        longitude: parseFloat(pickUpLon),
	        address_1: address,
	        state: state,
	        country: country,
	        city: city
	      },
	      guaranteed_tip_details: {
	        type: 'cents',
	        amount: tip
	      },
	      notes: notes,
	      requirements: { service_availability_ids: [serviceAvailabilitiesId] },
	      passenger: passenger,
	      auth_token: authToken,
	      payment_instrument: {
	        token: paymentToken
	      },
	      client_created_at: clientCreatedAt
	    });
	  },
	
	
	  /**
	   * Get the status of a specific ride
	   *
	   * @param {object} options - Options object parameter
	   * @param {number} options.rideId - The ride id
	   * @param {number} options.authToken - The authentication token
	   * @return {Promise} A promise that returns {@link RidePromise} if resolved and an object containing the error if rejected.
	  */
	  getRideStatus: function getRideStatus(_ref8) {
	    var rideId = _ref8.rideId;
	    var authToken = _ref8.authToken;
	
	    return _authorizedGetRequest({ rideId: rideId, authToken: authToken }, '/rides/' + rideId, authToken);
	  },
	
	
	  /**
	   * Cancel a specific ride
	   *
	   * @param {object} options - Options object parameter
	   * @param {number} options.rideId - The ride id
	   * @param {number} options.authToken - The authentication token
	   * @return {Promise} A promise that returns {@link RidePromise} if resolved and an object containing the error if rejected.
	  */
	  cancelRide: function cancelRide(_ref9) {
	    var rideId = _ref9.rideId;
	    var authToken = _ref9.authToken;
	
	    _verifyRequiredParams({ rideId: rideId, authToken: authToken });
	    var ridesUrl = '/rides/' + rideId;
	    return ax.post(ridesUrl + '/cancellation_contract', {
	      auth_token: authToken
	    }).then(function (response) {
	      return ax.put(ridesUrl, {
	        status: 'canceled',
	        auth_token: authToken
	      });
	    });
	  }
	};
	
	exports.default = flywheel;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("axios");

/***/ }
/******/ ]);
//# sourceMappingURL=flywheel.js.map